const configuredOrigin = (process.env.VUE_APP_API_ORIGIN || "").trim()
const browserOrigin =
  typeof window !== "undefined" && window.location
    ? window.location.origin
    : ""

export const apiOrigin = (
  configuredOrigin || browserOrigin || "https://a-residence.ru"
).replace(/\/+$/, "")

export const apiBaseUrl = `${apiOrigin}/panel/api/`

export const externalSubmissionsEnabled =
  process.env.VUE_APP_ENABLE_EXTERNAL_SUBMISSIONS !== "false"
